import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CanActivate } from '@angular/router';
import { MsalUserService } from '../../applicationinfraestructure/services/msaluser.service';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';

@Injectable()
export class ValidarMarcaCertificada implements CanActivate {

    paramLogin: string;

    constructor(
        private msalService: MsalUserService, 
        private router: Router,    
        private activeRoute: ActivatedRoute) { }

    canActivate() {
       
        if (environment.tipoUsuario=='MarcaCertificada' || environment.tipoUsuario=='Marca,MarcaCertificada' || environment.tipoUsuario=='AdministradorCertificadas' || environment.tipoUsuario=='Administrador'
        || environment.tipoUsuario=='ReporteMarca,Marca,MarcaCertificada'
        || environment.tipoUsuario=='ReporteMarca,MarcaCertificada'
        || environment.tipoUsuario=='Pactia') {
           
            return true;
        }
        else
      
        {
            Swal.fire({
                icon: 'error',
                title: 'Acceso Denegado...',
                text: 'Solo ingresan Marcas para registro de ventas certificadas.'
              })
            return false;}
    }
}